export const categoryTypes = {
  FETCH_CATEGORY_LOADING: "FETCH_CATEGORY_LOADING",
  FETCH_CATEGORY_SUCCESS: "FETCH_CATEGORY_SUCCESS",
  FETCH_CATEGORY_FAILURE: "FETCH_CATEGORY_FAILURE",
  FETCH_SUBCATEGORY_LOADING: "FETCH_SUBCATEGORY_LOADING",
  FETCH_SUBCATEGORY_SUCCESS: "FETCH_SUBCATEGORY_SUCCESS",
  FETCH_SUBCATEGORY_FAILURE: "FETCH_SUBCATEGORY_FAILURE",
};
